import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const conversationParticipantImporterSelectors =
  importerSelectors('conversationParticipant.importer')

export default conversationParticipantImporterSelectors
